import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { showAlert } from "@/plugins/alertDialog";
import Dashboard from "../views/Dashboard.vue";
import Items from "../views/Items.vue";
import Signin from "../views/Signin.vue";
import Accounts from "../views/Accounts.vue";
import CustomerDashboard from "../views/CustomerDashboard.vue";
import BatchImport from "../views/BatchImport.vue";
import Suppliers from "../views/Suppliers.vue";
import Employees from "../views/Employees.vue";
import UserAccounts from "../views/UserAccounts.vue";
import AccountProfile from "../views/AccountProfile.vue";
import Invoices from "../views/Invoices.vue";
import Units from "../views/Units.vue";
import Branches from "../views/Branches.vue";
import Quotations from "../views/Quotations.vue";
import PurchaseOrder from "../views/PurchaseOrder.vue";
import SupplierPurchaseOrder from "../views/SupplierPurchaseOrder.vue";
import InternalPurchaseOrder from "../views/InternalPurchaseOrder.vue";
import TaskManagement from "../views/TaskManagement.vue";
import Services from "../views/Services.vue";
import InventoryReports from "../views/InventoryReports.vue";
import ServiceReports from "../views/ServiceReports.vue";
import WarrantyPolicies from "../views/WarrantyPolicies.vue";
import RoleRestrictions from "../views/RoleRestrictions.vue";
import PrintableFormsMatrix from "../views/PrintableFormsMatrix.vue";
import Leads from "../views/Leads.vue";
import SalesDashboard from "../views/SalesDashboard.vue";
import SalesHub from "../views/SalesHub.vue";
import AdminSettings from "../views/AdminSettings.vue";
import ArAging from "../views/ArAging.vue";
import RecurringInvoices from "../views/RecurringInvoices.vue";
import InstalledSystems from "../views/InstalledSystems.vue";
import RmaItems from "../views/RmaItems.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    beforeEnter: (to, from, next) => {
      if (!store.getters["auth/authenticated"]) return next({ name: "Signin" });
      next();
    },
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
    beforeEnter: (to, from, next) => {
      if (store.getters["auth/authenticated"] && to.name !== "Signin") {
        return next({ name: "Dashboard" });
      }
      next();
    },
  },
  {
    path: "/branches",
    name: "Branches",
    component: Branches,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.branches")) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/warranty_policies",
    name: "Warranty Policies",
    component: WarrantyPolicies,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (
        !store.getters["permission/hasPermission"]("route.warranty_policies")
      ) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/user_accounts",
    name: "User Accounts",
    component: UserAccounts,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.user_accounts")) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/account_profile/:account_id",
    name: "Account Profile",
    component: AccountProfile,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.account_profile")) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/units",
    name: "Units",
    component: Units,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.units")) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },

  {
    path: "/invoices",
    name: "Invoices",
    component: Invoices,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.invoices")) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/ar_aging",
    name: "AR Aging",
    component: ArAging,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (
        !store.getters["permission/hasPermission"]("ar.view_aging_dashboard")
      ) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/recurring_invoices",
    name: "Recurring Invoices",
    component: RecurringInvoices,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (
        !store.getters["permission/hasPermission"]("route.recurring_invoices")
      ) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/installed_systems",
    name: "Installed Systems",
    component: InstalledSystems,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (
        !store.getters["permission/hasPermission"]("route.installed_systems")
      ) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/quotations",
    name: "Quotations",
    component: Quotations,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.quotations")) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/customer_purchase_orders",
    name: "Government Purchase Orders",
    component: PurchaseOrder,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (
        !store.getters["permission/hasPermission"](
          "route.customer_purchase_orders"
        )
      ) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/supplier_purchase_orders",
    name: "Supplier Purchase Orders",
    component: SupplierPurchaseOrder,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (
        !store.getters["permission/hasPermission"](
          "route.supplier_purchase_orders"
        )
      ) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/internal_purchase_orders",
    name: "Purchase Requests",
    component: InternalPurchaseOrder,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (
        !store.getters["permission/hasPermission"](
          "route.internal_purchase_orders"
        )
      ) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/customerDash",
    name: "Customer Dashboard",
    component: CustomerDashboard,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["customer/customer"]) {
        showAlert("You are not logged in!");
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      // if the user is not staff or admin
      if (
        !store.getters["permission/hasPermission"]("route.customer_dashboard")
      ) {
        showAlert("Unauthenticated access");
      }
      next();
    },
  },
  {
    path: "/items",
    name: "Item",
    component: Items,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        showAlert("Unauthenticated Access");
        return next({ name: "Signin" });
      }

      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.items")) {
        showAlert("Unauthenticated access");
        return;
      }
      next();
    },
  },
  {
    path: "/rma",
    name: "RMA Items",
    component: RmaItems,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        showAlert("Unauthenticated Access");
        return next({ name: "Signin" });
      }

      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.rma")) {
        showAlert("Unauthenticated access");
        return;
      }
      next();
    },
  },
  {
    path: "/services",
    name: "Services",
    component: Services,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        showAlert("Unauthenticated Access");
        return next({ name: "Signin" });
      }

      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.services")) {
        showAlert("Unauthenticated access");
        return;
      }
      next();
    },
  },
  {
    path: "/batch_import",
    name: "Batch Import",
    component: BatchImport,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        showAlert("Unauthenticated Access");
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.batch_import")) {
        showAlert("Unauthenticated access");
        return;
      }

      next();
    },
  },
  {
    path: "/suppliers",
    name: "Suppliers",
    component: Suppliers,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        showAlert("Unauthenticated Access");
        return next({ name: "Signin" });
      }

      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.suppliers")) {
        showAlert("Unauthenticated access");
        return;
      }

      next();
    },
  },
  {
    path: "/employees",
    name: "Employees",
    component: Employees,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        showAlert("Unauthenticated Access");
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.employees")) {
        showAlert("Unauthenticated access");
        return;
      }

      next();
    },
  },
  {
    path: "/accounts",
    name: "Accounts",
    component: Accounts,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        showAlert("Unauthenticated Access");
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.accounts")) {
        showAlert("Unauthenticated access");
        return;
      }
      next();
    },
  },
  {
    path: "/task_management",
    name: "Task Management",
    component: TaskManagement,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.task_management")) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/inventory_reports",
    name: "Inventory Reports",
    component: InventoryReports,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        showAlert("Unauthenticated Access");
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (
        !store.getters["permission/hasPermission"]("route.inventory_reports")
      ) {
        showAlert("Unauthenticated access");
        return;
      }
      next();
    },
  },
  {
    path: "/service_reports",
    name: "Service Reports",
    component: ServiceReports,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        showAlert("Unauthenticated Access");
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.service_reports")) {
        showAlert("Unauthenticated access");
        return;
      }
      next();
    },
  },
  {
    path: "/role_restrictions",
    name: "Role Restrictions",
    component: RoleRestrictions,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (
        !store.getters["permission/hasPermission"]("route.role_restrictions")
      ) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/printable-forms",
    name: "Printable Forms",
    component: PrintableFormsMatrix,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.printable_forms")) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/leads",
    name: "Leads",
    component: Leads,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.leads")) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    path: "/sales_dashboard",
    name: "Sales Dashboard",
    component: SalesDashboard,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.sales_dashboard")) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    // Consolidated admin control center (SMS, sales targets, users, roles, etc.).
    path: "/admin_settings",
    name: "Admin Settings",
    component: AdminSettings,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.admin_settings")) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
  {
    // Combined Sales workspace (analytics dashboard + Leads CRM in one page).
    path: "/sales",
    name: "Sales",
    component: SalesHub,
    beforeEnter: async (to, from, next) => {
      if (!store.getters["auth/authenticated"]) {
        return next({ name: "Signin" });
      }
      await store.dispatch("permission/ensure_user_permissions");
      if (!store.getters["permission/hasPermission"]("route.sales_dashboard")) {
        showAlert("Unauthenticated");
        return;
      }
      next();
    },
  },
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
